import React, { createContext, useContext, useState } from 'react'
import { useDispatch } from 'react-redux'
import  { auth } from '../../config/firebaseConfig'
import { LOGIN_FAILURE, LOGIN_REQUEST, LOGIN_SUCCESS } from '../../redux/ActionType/ActionType'
import Loading from '../../shared/components/Loading'


const AuthContext = createContext()

export function useAuth(){
    const {currentUser, setCurrentUser, handleLogin} =  useContext(AuthContext)
    return {currentUser, setCurrentUser, handleLogin}
}

const AuthProvider = ({children}) => {
   const [currentUser, setCurrentUser] = useState(auth.currentUser)
   const [pending, setPending] = useState(true)
   const actionDispatch = useDispatch()

   const handleLogin=({email, password}, isFine, isWrong)=>{

            actionDispatch({type:LOGIN_REQUEST});

           auth.signInWithEmailAndPassword(email, password)
            .then(result=>{

                setCurrentUser(result.user)
                actionDispatch({type:LOGIN_SUCCESS, currentUser : result.user})
                isFine(result.user);
            })
            .catch(error=>{
                actionDispatch({type: LOGIN_FAILURE, error : error});
                 isWrong();
            })
   }


    React.useEffect(()=>{
        auth.onAuthStateChanged((user)=>{
            setCurrentUser(user)
            setPending(false)
        })
    })

    const store={
        currentUser : currentUser,
        setCurrentUser,
        handleLogin,
    }

    if(pending){
        return <> <Loading height={1000} /> </>
    }

    return (
        <AuthContext.Provider value={store}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthProvider
